import React from 'react'

const Store = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="40" cy="40" r="40" fill="white" />
            <g opacity="0.5">
                <g opacity="0.5">
                    <path
                        opacity="0.5"
                        d="M25.239 37.5678L28.4905 18.3673H20.7858L14.8058 37.5678C14.8058 37.5678 16.3043 39.6164 19.669 39.6164C23.0336 39.6164 25.239 37.5678 25.239 37.5678Z"
                        fill="#EEE0B9"
                    />
                </g>
            </g>
            <g opacity="0.5">
                <g opacity="0.5">
                    <path
                        opacity="0.5"
                        d="M55.9589 37.9069L52.7074 18.7064H60.4121L66.3921 37.9069C66.3921 37.9069 64.8936 39.9555 61.5289 39.9555C58.1643 39.9555 55.9589 37.9069 55.9589 37.9069Z"
                        fill="#EEE0B9"
                    />
                </g>
            </g>
            <g opacity="0.5">
                <g opacity="0.5">
                    <path
                        opacity="0.5"
                        d="M45.7661 37.9069L44.1262 18.7064H36.4215L35.347 37.9069C35.347 37.9069 36.8456 39.9555 40.2102 39.9555C43.5607 39.9555 45.7661 37.9069 45.7661 37.9069Z"
                        fill="#EEE0B9"
                    />
                </g>
            </g>
            <path
                d="M32.8325 22.2967C32.2423 23.3213 31.8556 24.4427 31.692 25.6036L30.8478 29.4664C30.2193 31.9221 29.955 34.4511 30.0628 36.9782C30.1337 38.2426 30.4865 39.4775 31.0973 40.599C31.7081 41.7206 32.5626 42.7024 33.6027 43.478C34.6674 44.2203 35.9701 44.5773 37.2815 44.486C38.5928 44.3948 39.8287 43.8611 40.7713 42.9791C41.5737 41.992 42.0852 40.8153 42.2524 39.5724C42.7585 36.0591 42.6986 32.4917 42.0747 28.996C41.9657 27.0216 41.4628 25.0859 40.5936 23.2944C38.9643 20.4436 34.9653 19.0895 32.8325 22.2967Z"
                fill="#EF8078"
            />
            <path
                d="M50.3785 26.2266C49.9195 29.0131 49.8004 31.8427 50.0237 34.6565C50.0125 36.7953 50.6446 38.8905 51.8421 40.684C53.1145 42.1841 54.9401 43.1394 56.9277 43.3453C58.0307 43.5569 59.1728 43.4582 60.2202 43.0607C61.2675 42.6633 62.1768 41.9835 62.8413 41.1012C64.0388 39.1591 63.4031 36.6992 62.723 34.5414L59.7663 25.2627C59.0714 23.1337 57.7704 20.0983 54.9911 20.4724C52.2117 20.8464 50.8072 23.7954 50.3785 26.2266Z"
                fill="#EF8078"
            />
            <path
                d="M62.178 36.6123C60.7739 32.914 56.7864 25.8588 56.8847 22.0324C56.8847 21.4919 23.1872 21.3923 23.1872 21.563C21.9236 27.6795 17.6552 35.7873 18.6942 39.6563C19.649 43.2978 27.1186 43.9236 30.2918 40.4387C31.8508 41.8091 33.844 42.5664 35.908 42.5723C38.1014 42.6612 40.2551 41.9608 41.9876 40.5951C46.3121 43.7103 51.2965 43.0133 53.3184 40.5951C57.685 44.4499 62.5571 41.7758 63.3293 39.9977C63.9191 38.5753 62.9924 37.8641 61.9253 38.5753C61.4985 38.886 61.2027 39.3481 61.0969 39.8697C60.9939 40.3843 60.9608 40.9107 60.9986 41.4344C61.0969 47.1241 61.139 52.9276 61.3215 58.66C61.3612 58.9616 61.3123 59.2683 61.1811 59.5419C60.774 60.1678 47.1405 60.2673 46.8035 60.0398C46.4666 59.8122 48.4323 48.3047 40.7942 48.4896C33.1561 48.6745 36.6522 59.8691 36.1046 60.1678C35.6553 60.2958 21.2216 59.8548 21.2216 59.7268C21.2216 59.5988 21.9376 49.2577 21.2216 43.4542"
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Store
